import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $libraryFavoritesMoviesTranslations = combine(
  i18n.$t,
  ({ t }) => ({
    movies: t('movies_favorite'),
  })
)
